module.exports = __webpack_public_path__ + "assets/ATrByOrthocenterDetailed.335a5e9af9c3431cc625fbab2047dc0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ATrByOrthocenterDetailed.png
// module id = 457
// module chunks = 0